<template>
  <div>
    <div class="log-header">
      <div class="log-container">
        <div class="brand"><img :src="brand" alt=""></div>
        <div class="log-welcome">欢迎登录</div>
      </div>
    </div>
    <div class="log-body" :style="{backgroundImage: 'url('+login_bg+')', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}">
      <div class="log-container">
      <el-tabs type="border-card" @tab-click="tabChange" value="admin" style="width:400px" class="login-type-tab">
        <el-tab-pane v-if="system_mode !== 'group'" name="admin" label="管理员登录(shopexid)">
            <div class="log-img"></div>
            <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-position="left" label-width="0px" class="login-log-container">
              <h3 class="title"><!--<a href="http://yyk.shopex.cn/signup" target="_blank" class="signup">免费注册</a>--></h3>
              <el-form-item prop="account">
                <el-input type="text" v-model="ruleForm1.account" name="account"  :autofocus="true" autocomplete="on" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item prop="checkPass">
                <el-input type="password" v-model="ruleForm1.checkPass" name="password" autocomplete="on" placeholder="密码"></el-input>
              </el-form-item>
              <el-form-item prop="verify">
                <el-input type="text"  name="verify"  v-model="ruleForm1.verify" autocomplete="off" :disabled="disabled" placeholder="验证码">
                  <el-button @click="verifysubmit" type="button" slot="append" :disabled="disabled_button">{{verify_text}}</el-button>
                </el-input>
                <Vcode :show="isShow" @success="onSuccess" @close="onClose" />
              </el-form-item>
              <el-form-item class="log-opr clearfix">
                <el-checkbox v-model="checked" checked class="remember f_l">记住密码</el-checkbox>
                <!--<a href="https://account.shopex.cn/forget?" target="_blank" class="forget-pwd">忘记密码</a>-->
              </el-form-item>
              <el-form-item style="width:100%">
                <el-button type="primary" style="width:100%" @click.native.prevent="handleSubmit1" :loading="logining" :disabled="submitDisabled">登录</el-button>
              </el-form-item>
            </el-form>
        </el-tab-pane>
        <el-tab-pane v-if="system_mode === 'group'" name="localadmin" label="管理员登录(独立账号)">
            <div class="log-img"></div>
            <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-position="left" label-width="0px" class="login-log-container">
              <h3 class="title"><!--<a href="http://yyk.shopex.cn/signup" target="_blank" class="signup">免费注册</a>--></h3>
              <el-form-item prop="account">
                <el-input type="text" v-model="ruleForm1.account" name="account" :autofocus="true" autocomplete="on" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item prop="checkPass">
                <el-input type="password" v-model="ruleForm1.checkPass" name="password" autocomplete="on" placeholder="密码"></el-input>
              </el-form-item>
              <el-form-item prop="verify">
                <el-input type="text"  name="verify" v-model="ruleForm1.verify"  :disabled="disabled" autocomplete="off" placeholder="验证码">
                  <el-button @click="verifysubmit" type="button" slot="append" :disabled="disabled_button" >{{verify_text}}</el-button>
                </el-input>
                <Vcode :show="isShow" @success="onSuccess" @close="onClose" />
              </el-form-item>
              <el-form-item class="log-opr clearfix">
                <el-checkbox v-model="checked" checked class="remember f_l">记住密码</el-checkbox>
                <a href="https://account.shopex.cn/forget?" target="_blank" class="forget-pwd">忘记密码</a>
              </el-form-item>
              <el-form-item style="width:100%">
                <el-button type="primary" style="width:100%" @click.native.prevent="handleSubmit1" :loading="logining" :disabled="submitDisabled">登录</el-button>
              </el-form-item>
            </el-form>
        </el-tab-pane>
        <el-tab-pane name="staff" label="员工账号登录">
            <div class="log-img"></div>
            <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-position="left" label-width="0px" class="login-log-container">
              <h3 class="title"></h3>
              <el-form-item prop="account">
                <el-input type="text" v-model="ruleForm1.account" name="account" :autofocus="true" autocomplete="on" placeholder="请输入手机号" clearable></el-input>
              </el-form-item>
              <el-form-item prop="checkPass">
                <el-input type="password" v-model="ruleForm1.checkPass" name="password" autocomplete="on" placeholder="密码" clearable show-password></el-input>
              </el-form-item>
              <el-form-item prop="verify">
                <el-input type="text" name="verify" v-model="ruleForm1.verify" :disabled="disabled" autocomplete="off" placeholder="验证码" clearable>
                  <el-button @click="verifysubmit" type="button" slot="append" :disabled="disabled_button">{{verify_text}}</el-button>
                </el-input>
                <Vcode :show="isShow" @success="onSuccess" @close="onClose" />
              </el-form-item>
              <el-form-item v-if="system_is_saas == 'false'" class="log-opr clearfix title">
                忘记密码，请联系管理员后台重置
              </el-form-item>
              <el-form-item v-if="system_is_saas == 'true'" class="log-opr clearfix">
                <router-link to="/forget" class="forget-pwd">忘记密码</router-link>
              </el-form-item>
              <el-form-item style="width:100%">
                <el-button type="primary" style="width:100%" @click.native.prevent="handleSubmit1" :loading="logining" :disabled="submitDisabled">登录</el-button>
              </el-form-item>
            </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>

    </div>
    <div class="log-footer" style="padding-bottom: 10px;">
      <a href="http://www.yaoking.cn/article-cominfo_gongsizizhi-70.html" target="_blank">联网药品信息资格证 </a>
      <span>|</span>
      <a href="http://www.yaoking.cn/article-cominfo_gongsizizhi-76.html" target="_blank">药品经营许可证 </a>
      <span>|</span>
      <a href="http://www.yaoking.cn/article-cominfo_gongsizizhi-77.html" target="_blank">医疗器械许可证 </a>
      <span>|</span>
      <a href="http://www.yaoking.cn/article-cominfo_gongsizizhi-75.html" target="_blank">食品流通许可证 </a>
      <span>|</span>
      <a href="http://www.yaoking.cn/article-cominfo_gongsizizhi-92.html" target="_blank">化妆品网销质量承诺书 </a>
     <!-- <span>友情链接：</span>
      <a href="https://mp.weixin.qq.com/cgi-bin/loginpage?t=wxm2-login&lang=zh_CN" target="_blank">微信公众平台</a>
      <span>|</span>
      <a href="https://www.alipay.com/" target="_blank">支付宝</a>
      <span>|</span>
      <a href="http://e.qq.com/ads" target="_blank">腾讯社交广告</a>-->
    </div>
    <div class="log-footer" style="padding: 0;">
      <span>互联网药品信息资格证：</span>
      <a href="http://www.yaoking.cn/article-cominfo_gongsizizhi-70.html" target="_blank">(陕)-非经营性-2016-0002 </a> &emsp;
      <span>增值电信业务经营许可证：
      </span>
      <a href="http://www.yaoking.cn/article-cominfo_gongsizizhi-93.html" target="_blank">陕B2-20190122</a>
    </div>
    <div class="log-footer" style="padding: 10px 0;">
      ©怡康医药网上药店 怡康到家官网 2001-2020 All Rights Reserved. 陕ICP备06006817号
    </div>
  </div>
</template>

<script>
  import Vcode from  "vue-puzzle-vcode";
  import { isMobile } from '../utils/validate'
  import fetch from '../utils/fetch'
  import { login, getAdminInfo, authSmsSend } from '../api/login'
  import loadRouters from '../router/loadRouters'
  export default {
    components: {
      Vcode,
    },
    data () {
      const validateEmail = (rule, value, callback) => {
        if (!isMobile(value)) {
          callback(new Error('请输入正确的合法手机号'))
        } else {
          callback()
        }
      }
      const validatePass = (rule, value, callback) => {
        if (value.length < 6) {
          callback(new Error('密码不能小于6位'))
        } else {
          callback()
        }
      }
      const validateVerify = (rule, value, callback) => {
        if (value.length < 6 ) {
          callback(new Error('请输入正确的验证码'))
        } else {
          callback()
        }
      }
      return {
        brand: '',
        login_bg: '',
        logining: false,
        ruleForm1: {
          account: '',
          checkPass: '',
          verify: '',
          loginType: 'admin'
        },
        rules1: {
          account: [
            { required: true, trigger: 'blur', validator: validateEmail }
          ],
          verify: [
            { required: true,tigger: 'blur', validator: validateVerify }
          ],
          checkPass: [
            { required: true, trigger: 'blur', validator: validatePass }
          ]
        },
        checked: true,
        disabled:false,
        submitDisabled: false,
        isShow: false,
        verify_text: '发送验证码',
        text: '发送验证码',
        disabled_button:false
      }
    },
    methods: {
      verifysubmit() {
        if(isMobile(this.ruleForm1.account)){
          this.isShow = true;
        }else{
          this.$message({ message: '请输入正确的合法手机号', type: 'error', duration: 3000 })
        }

      },
      onSuccess(msg) {
        this.isShow = false; // 通过验证后，需要手动关闭模态框
        this.sendSms();
        var time=60;
        this.verify_text=time;
        var timer=setInterval(()=>{
          time--;
          this.verify_text=time;
          this.disabled_button=true
          if(time <=0){
            this.verify_text=this.text;
            this.disabled_button=false
            clearInterval(timer);
          }
        },1000);

      },
      sendSms(){
        var params={ account:this.ruleForm1.account}
        authSmsSend(params).then(response => {
          if(response.data.data.status == 0){
            this.$message({ message: response.data.data.msg, type: 'error', duration: 3000 })
          }else if(response.data.data.status == 2){
            this.$message({ message:response.data.data.msg, type: 'error', duration: 3000 })
          }else{
            this.$message({ message: response.data.data.msg, type: 'success', duration: 3000 })
          }
        });
      },
      onClose() {
        this.isShow = false;
      },
      tabChange (e) {
        this.ruleForm1.loginType = e.name
        this.ruleForm1.account = ''
        this.ruleForm1.checkPass = ''
        this.ruleForm1.verify = ''
        this.verify_text=this.text;
        this.disabled_button=false
        clearInterval(this.timer);
      },
      handleSubmit1 () {
        if(!isMobile(this.ruleForm1.account)){
          this.$message({ message: '请输入正确手机号！', type: 'error', duration: 3000 })
        }

        if(this.ruleForm1.verify == ''){
          this.$message({ message: '请输入正确的验证码！', type: 'error', duration: 3000 })
        }
        if(!this.ruleForm1.checkPass){
          this.$message({ message: '请输入密码！', type: 'error', duration: 3000 })
        }

        this.$store.dispatch('setLoginType', 'default')
        setTimeout(function(){}, 200);

        const _self = this
        this.$refs.ruleForm1.validate((valid) => {
          if (valid) {
            this.loading = true
            this.submitDisabled = true
            var params = { username: this.ruleForm1.account, password: this.ruleForm1.checkPass, logintype: this.ruleForm1.loginType,verify:this.ruleForm1.verify ,person_origin:'admin'}
            login(params).then(response => {
              this.$store.dispatch('setToken', response.data.data.token)
              this.loading = false
              fetch({ url: '/permission', method: 'get'}).then(res=> {
                if(res.data.data) {
                  const url = this.path_prefixes ? res.data.data[0]['url'] == '/' ? `/${this.path_prefixes}` : `${this.path_prefixes}${res.data.data[0]['url']}` : res.data.data[0]['url']
                  getAdminInfo().then(info => {
                    this.$message({
                      message: '登录成功',
                      type: 'success',
                      duration: 2 * 1000,
                      onClose() {
                        _self.$store.dispatch('setUser', info.data.data)
                        _self.$router.push({path: url })
                        _self.$router.go(0)
                      }
                    })
                  })
                  this.$store.dispatch('setMenu', res.data.data)
                } else {
                  this.$message({ message: '当前账号没有权限，请联系管理员', type: 'error', duration: 3 * 1000 })
                  this.submitDisabled = false
                }
              })
            }).catch((error) => {
              this.submitDisabled = false
            })
          } else {
            this.submitDisabled = false
            return false
          }
        })
      }
    },
    mounted() {
      this.$store.dispatch('setLoginType', 'default')
      this.brand = require('../../static/img/'+this.companyBrandImg+'/logo.svg')
      this.login_bg = require('../../static/img/'+this.companyBrandImg+'/login_bg.jpg')
    }
  }
</script>

<style lang="scss" scoped>
  body {
    background: #eaeaea;
  }
  .log-header {
    padding: 20px 0;
    background: #fff;
  }
  .brand {
    display: inline-block;
    width: 150px;
    vertical-align: middle;
  }
  .brand img {
    width: 100%;
    height: auto;
  }
  .log-welcome {
    display: inline-block;
    padding-left: 24px;
    margin-left: 24px;
    border-left: 1px solid #efefef;
    vertical-align: middle;
  }
  .log-body {
    padding: 118px 0;
    // background: url(/static/img/login_bg.jpg) no-repeat center center;
    background-size: cover;
  }
  .log-img {
    float: left;
    width: 360px;
    padding-top: 5px;
    padding-left: 50px;
  }
  .log-img img {
    width: 100%;
    height: auto;
  }
  .log-container {
    width: 900px;
    margin: 0 auto;
  }
  .log-container::after {
    display: table;
    clear: both;
    content: "";
  }
  .login-log-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02)*/
    float: right;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    width: 290px;
    padding: 0px 35px 15px 35px;
    background: #fff;
    //border: 1px solid #eaeaea;
    .title {
      margin: 0px auto 35px auto;
      text-align: center;
      color: #505458;
      position: relative;
      font-size: 18px;
    }
    .remember {
      // margin: 0px 0px 35px 0px;
      float: left;
    }
    .log-opr {
      margin-bottom: 10px;
    }
    .signup {
      color: #ff5000;
      font-size: 14px;
      position: absolute;
      right: 0;
      line-height: 27px;
      &:hover {
        text-decoration: underline;
      }
    }
    .forget-pwd {
      float: right;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .el-form-item {
    margin-bottom: 30px;
  }
  .log-footer {
    color: #999;
    text-align: center;
    padding: 30px 0;
    a {
      color: #999;
      margin: 0 5px;
      &:hover {
        color: #ff5000;
      }
    }
  }
  .login-type-tab {
    float: right;
  }
</style>
<style lang="scss">
  .log-body {
    .el-input {
    .el-input__inner {
      height: 38px;
    }
  }
  }
</style>



// WEBPACK FOOTER //
// login.vue?37fdf546